import { render, staticRenderFns } from "./mallPayPopup.vue?vue&type=template&id=20f606cc&scoped=true&"
import script from "./mallPayPopup.vue?vue&type=script&lang=js&"
export * from "./mallPayPopup.vue?vue&type=script&lang=js&"
import style0 from "./mallPayPopup.vue?vue&type=style&index=0&id=20f606cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../layers/paketo-buildpacks_npm-install/build-modules/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f606cc",
  null
  
)

export default component.exports